import { useCallback, useContext, useEffect, useState } from 'react';
import history from '@history';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import WdPageSimple from '@main/core/WdPageSimple';
import { ComposedHeader, ComposedStepper, FormCardLayout, RequestLogger } from '@main/components';
import { useDispatch, useSelector } from 'react-redux';
import {
  hideConnetionMongodb,
  hideConnetionPlesk,
  hideConnetionRepository,
} from 'app/store/modals';
import { MongodbConnection, PleskConnection, RepositoryConnection } from 'src/app/modals';
import {DataBases, Interfaces, Laravel, Plesk, Register, Initialize, Acl} from './Steps';
import { StepperContext, StepperProvider } from './Context/SetupContext';
import { Services } from './Steps/Services';

const stepsData = [
  'Registro',
  'Plesk',
  'Bases de datos',
  'ACL (Permisos)',
  'Repositorios',
  'Laravel',
  'Servicios',
  'Initializar',
];

const Root = styled(WdPageSimple)(({ theme }) => ({
  backgroundColor: '#FFF',
  '& .WdPageSimple-header': {},
  '& .WdPageSimple-content': {},
}));

const MainLayout = () => {
  const { currentStep, setCurrentStep, loggerCache, companyId } = useContext(StepperContext);
  const [disableNextStep, setDisableNextStep] = useState(false);

  const handleChangeStep = (nextStep) => {
    if (typeof nextStep !== 'number' || nextStep === undefined || nextStep === currentStep) return;
    setCurrentStep(nextStep);
  };

  const changeTagPage = useCallback(() => {
    setDisableNextStep(false);
    if (currentStep === 7) {
      handleOnFinishedWizard();
      return;
    }
    const nextStep = currentStep + 1;
    if (nextStep >= stepsData.length) return;
    setCurrentStep(nextStep);
  }, [currentStep]);

  const handleEnableDisableSubmitBtn = (isDisabled) => {
    setDisableNextStep(Boolean(isDisabled));
  };

  const handleOnFinishedWizard = () => {
    history.replace(`/companies/info?id=${companyId}`);
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <Root
      header={<ComposedHeader decorator="button" />}
      content={
        <Box
          className="flex justify-center items-start"
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          {/* <FormCardLayout maxWidth="86.5rem"> */}
          <FormCardLayout maxWidth="140.5rem">
            <FormCardLayout.FullColum>
              <div className="mt-24 w-full flex flex-wrap">
                <ComposedStepper stepsData={stepsData} step={currentStep} />
              </div>
            </FormCardLayout.FullColum>
            {currentStep === 0 && <Register onSuccess={() => handleChangeStep(1)} />}
            {currentStep === 1 && <Plesk onSuccess={handleEnableDisableSubmitBtn} />}
            {currentStep === 2 && <DataBases onSuccess={handleEnableDisableSubmitBtn} />}
            {currentStep === 3 && <Acl onSuccess={handleEnableDisableSubmitBtn} />}
            {currentStep === 4 && <Interfaces onSuccess={handleEnableDisableSubmitBtn} />}
            {currentStep === 5 && <Laravel onSuccess={handleEnableDisableSubmitBtn} />}
            {currentStep === 6 && <Services onSuccess={handleEnableDisableSubmitBtn} />}
            {currentStep === 7 && <Initialize onSuccess={handleEnableDisableSubmitBtn} />}
            {currentStep !== 0 && (
              <FormCardLayout.FullColum>
                <RequestLogger component="pre" className="language-json">
                  {loggerCache || ''}
                </RequestLogger>
              </FormCardLayout.FullColum>
            )}
            {currentStep !== 0 && (
              <FormCardLayout.RowButton>
                <Button
                  onClick={() => history.replace('/companies')}
                  variant="contained"
                  className="w-full md:w-auto"
                  color="primary"
                >
                  Cancelar
                </Button>
                <Button
                  disabled={!disableNextStep}
                  onClick={() => changeTagPage()}
                  variant="contained"
                  aria-label="Crear suscripcion"
                  className="w-full md:w-auto"
                  color="success"
                  // disabled={_.isEmpty(dirtyFields) || !isValid}
                >
                  Continuar
                </Button>
              </FormCardLayout.RowButton>
            )}
          </FormCardLayout>
        </Box>
      }
    />
  );
};

export const Setup = () => {
  const { pleskConnections, databases, gitVersions } = useSelector((state) => state.modals);
  const {
    visibility: visibilityPlesk,
    data: dataPlesk,
    selected: selectedPlesk,
  } = pleskConnections;
  const { visibility: visibilityMongo, data: dataMongo, selected: selectedMongo } = databases;
  const { visibility: visibilityRepo, data: dataVersion, selected: selectedVersion } = gitVersions;
  const dispatch = useDispatch();

  const handleOnHidePleskConnection = () => {
    dispatch(hideConnetionPlesk());
  };

  const handleOnHideMongodb = () => {
    dispatch(hideConnetionMongodb());
  };

  const handleOnHideVersion = () => {
    dispatch(hideConnetionRepository());
  };

  return (
    <StepperProvider>
      {/* --------------- | Modales | ------------------------- */}
      <PleskConnection
        title="Conexión Plesk"
        show={visibilityPlesk}
        data={dataPlesk}
        selected={selectedPlesk}
        onHide={handleOnHidePleskConnection}
      />
      <MongodbConnection
        title="Conexión MongoDB"
        show={visibilityMongo}
        data={dataMongo}
        selected={selectedMongo}
        onHide={handleOnHideMongodb}
      />
      <RepositoryConnection
        title="Version del Repositorio"
        show={visibilityRepo}
        data={dataVersion}
        selected={selectedVersion}
        onHide={handleOnHideVersion}
      />
      <MainLayout />
    </StepperProvider>
  );
};
